/* =========================================================
   CHAGUAL — Filtro nativo mobile-first para Maceteros
   Provee la UI propia SOLO en la coleccion maceteros.

   Contrato:
   - Init SOLO si existe el owner exacto [data-ch-filter-count-owner="maceteros"];
     marca body.ch-maceteros-filter
     (habilita en CSS el estado visual del filtro propio).
   - Mono-select por grupo (radio): al elegir una opcion se desmarca la hermana del grupo.
     AND entre grupos (path de tags nativo: /collections/maceteros/tag1+tag2).
   - Conteos combinados EN VIVO desde el blob JSON #ch-mf-data (deshabilita opcion -> 0).
   - "Ver N resultados" (apply) hace swap PROPIO y atomico del bloque
     [data-ch-filter-results] (contador + grilla + paginacion/load-more), luego pushState
     y emite el evento propio chagual:catalog-updated.
     NO reutiliza el swap AJAX legacy del theme (roto en basic_pagination: asume un icono de
     carga inexistente y deja la grilla en blanco).
   - Fallback si falla fetch / no encuentra grid: location.assign(url).
   ========================================================= */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-collection-ui="maceteros"][data-ch-filter-count-owner="maceteros"]');
    if (!root) return;

    document.body.classList.add('ch-maceteros-filter');

    var drawer = document.querySelector('[data-ch-mf]');
    if (!drawer) return;
    var panel = drawer.querySelector('.ch-mf__panel');
    var lastOpener = null;

    // --- Contrato transversal compartido por los cinco filtros propios
    //     (assets/chagual-filter-contract.js). Resolucion perezosa y tolerante:
    //     si esa capa no cargo, el filtro sigue operando igual que antes. ---
    function shared(name) {
      var api = window.ChagualFilterContract;
      var fn = api && api[name];
      return typeof fn === 'function' ? fn : function () {};
    }

    function appliedFacets() {
      return GROUPS.filter(function (group) { return applied[group]; })
        .map(function (group) { return { facet: group, value: applied[group] }; });
    }

    function syncOpeners(open) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ch-filter-open]'), function (opener) {
        opener.setAttribute('aria-controls', drawer.id);
        opener.setAttribute('aria-expanded', open && opener === lastOpener ? 'true' : 'false');
      });
    }

    var GROUPS = ['tamano', 'color', 'caracteristicas'];
    var COLLECTION_URL = root.getAttribute('data-collection-url') || window.location.pathname;

    // --- Blob de productos (conteos combinados). El paginate propio del blob comparte
    //     el parametro `page` con el grid, asi que en /collections/maceteros?page=2 llega
    //     vacio (hallazgo P1 numero 5 de la auditoria 16: "Maceteros pierde conteos al
    //     cargar directamente paginas 2 o 3"). El servidor publica el total real del
    //     catalogo y la URL sin paginar; si el blob servido no cubre el catalogo completo,
    //     los datos de facetas se piden aparte, SIN tocar la paginacion de la grilla. ---
    function parseFacetBlob(node) {
      if (!node) return [];
      var parsed;
      try { parsed = JSON.parse(node.textContent || '[]'); } catch (e) { return []; }
      return Array.isArray(parsed) ? parsed : [];
    }
    var dataEl = document.getElementById('ch-mf-data');
    var PRODUCTS = parseFacetBlob(dataEl);
    var countsOn = PRODUCTS.length > 0;
    var CATALOG_TOTAL = dataEl ? parseInt(dataEl.getAttribute('data-ch-mf-catalog-total'), 10) : NaN;
    var CATALOG_URL = dataEl ? (dataEl.getAttribute('data-ch-mf-catalog-url') || '') : '';

    function facetDataComplete() {
      if (isNaN(CATALOG_TOTAL) || CATALOG_TOTAL <= 0) return countsOn;
      return PRODUCTS.length === CATALOG_TOTAL;
    }

    // Repone los datos de facetas desde el catalogo completo cuando la pagina servida
    // no los trae. Nunca publica numeros a medias: si la respuesta no cubre el total
    // declarado por el servidor, se queda como estaba (filtro por URL, sin conteos).
    function hydrateFacetData() {
      if (facetDataComplete()) return;
      if (!CATALOG_URL || isNaN(CATALOG_TOTAL) || CATALOG_TOTAL <= 0) return;
      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;
      fetch(CATALOG_URL, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('facetas');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var full = parseFacetBlob(doc.getElementById('ch-mf-data'));
          if (full.length !== CATALOG_TOTAL) return;
          PRODUCTS = full;
          countsOn = true;
          render();
        })
        .catch(function () {});
    }

    var optionEls = Array.prototype.slice.call(drawer.querySelectorAll('[data-ch-filter]'));

    // Etiquetas legibles por tag (fuente unica = el markup del drawer) para los chips activos.
    var LABELS = {};
    optionEls.forEach(function (btn) {
      var labelNode = btn.querySelector('.ch-mf__option-label');
      LABELS[btn.getAttribute('data-tag')] = labelNode ? labelNode.textContent.trim() : btn.getAttribute('data-tag');
    });

    // Estado de seleccion (staging): group -> tag. Se deriva siempre de la URL
    // para que Atrás/Adelante restauren grilla, chips y contador como una unidad.
    function selectionFromPath(pathname) {
      var next = {};
      var parts = pathname.split('/').filter(Boolean);
      var ci = parts.indexOf('collections');
      var seg = (ci >= 0 && parts.length > ci + 2) ? parts[ci + 2] : '';
      if (!seg) return next;
      var urlTags = seg.split('+').map(function (s) {
        try { return decodeURIComponent(s).toLowerCase(); } catch (e) { return s.toLowerCase(); }
      });
      optionEls.forEach(function (btn) {
        var tag = btn.getAttribute('data-tag');
        var group = btn.getAttribute('data-group');
        if (urlTags.indexOf(tag) !== -1 && !next[group]) next[group] = tag;
      });
      return next;
    }
    var selected = selectionFromPath(window.location.pathname);

    // --- Estado APLICADO (lo que refleja la URL / el grid), distinto del staging `selected`.
    //     Los chips EN LA PAGINA (G) muestran lo aplicado, no lo tentativo del cajon. ---
    function cloneSel(src) {
      var o = {};
      GROUPS.forEach(function (g) { if (src[g]) o[g] = src[g]; });
      return o;
    }
    var applied = cloneSel(selected);

    // --- Helpers de conteo ---
    function selectedTags() {
      return GROUPS.map(function (g) { return selected[g]; }).filter(Boolean);
    }
    function productMatches(prod, tags) {
      var t = prod && prod.t ? prod.t : [];
      for (var i = 0; i < tags.length; i++) { if (t.indexOf(tags[i]) === -1) return false; }
      return true;
    }
    function countForCombo(tags) {
      var n = 0;
      for (var i = 0; i < PRODUCTS.length; i++) { if (productMatches(PRODUCTS[i], tags)) n++; }
      return n;
    }
    function countForOption(tag, group) {
      var others = GROUPS.filter(function (g) { return g !== group; })
        .map(function (g) { return selected[g]; }).filter(Boolean);
      return countForCombo(others.concat([tag]));
    }
    function totalCount() {
      var tags = selectedTags();
      if (!tags.length) return PRODUCTS.length;
      return countForCombo(tags);
    }

    // --- Chips activos (propios) ---
    var activeRow = drawer.querySelector('[data-ch-active]');
    function renderActive() {
      if (!activeRow) return;
      var tags = selectedTags();
      if (!tags.length) { activeRow.hidden = true; activeRow.innerHTML = ''; return; }
      activeRow.hidden = false;
      var html = '';
      GROUPS.forEach(function (g) {
        var tag = selected[g];
        if (!tag) return;
        html += '<button type="button" class="ch-mf__chip" data-ch-remove="' + g + '">' +
          '<span class="ch-mf__chip-label">' + (LABELS[tag] || tag) + '</span>' +
          '<span class="ch-mf__chip-x" aria-hidden="true">&times;</span>' +
          '<span class="ch-mf__chip-a11y">Quitar filtro ' + (LABELS[tag] || tag) + '</span>' +
          '</button>';
      });
      activeRow.innerHTML = html;
    }

    // --- Chips activos EN LA PAGINA (G): reflejan lo APLICADO; se pueden quitar sin reabrir. ---
    var activePageRow = document.querySelector('[data-ch-active-page]');
    function appliedTags() {
      return GROUPS.map(function (g) { return applied[g]; }).filter(Boolean);
    }
    function renderActivePage() {
      if (!activePageRow) return;
      var tags = appliedTags();
      if (!tags.length) { activePageRow.hidden = true; activePageRow.innerHTML = ''; return; }
      activePageRow.hidden = false;
      var html = '';
      GROUPS.forEach(function (g) {
        var tag = applied[g];
        if (!tag) return;
        var label = LABELS[tag] || tag;
        html += '<button type="button" class="ch-mf-active-page__chip" data-ch-page-remove="' + g + '">' +
          '<span class="ch-mf-active-page__label">' + label + '</span>' +
          '<span class="ch-mf-active-page__x" aria-hidden="true">&times;</span>' +
          '<span class="ch-mf__chip-a11y">Quitar filtro ' + label + '</span>' +
          '</button>';
      });
      activePageRow.innerHTML = html;
    }

    // --- Boton "Ver N resultados" ---
    var applyBtn = drawer.querySelector('[data-ch-apply]');
    var totalNode = drawer.querySelector('[data-ch-total]');
    function renderTotal() {
      if (!applyBtn) return;
      if (!countsOn) { applyBtn.textContent = 'Ver resultados'; return; }
      var n = totalCount();
      if (totalNode) { totalNode.textContent = n; }
      else { applyBtn.textContent = 'Ver ' + n + ' resultados'; }
    }

    // --- Render principal (counts + estados) ---
    function render() {
      optionEls.forEach(function (btn) {
        var tag = btn.getAttribute('data-tag');
        var group = btn.getAttribute('data-group');
        var isSel = selected[group] === tag;
        btn.setAttribute('aria-checked', isSel ? 'true' : 'false');
        btn.classList.toggle('is-selected', isSel);

        var countNode = btn.querySelector('[data-ch-count-for]');
        if (countsOn) {
          var c = countForOption(tag, group);
          if (countNode) countNode.textContent = c;
          var dead = c === 0 && !isSel;
          btn.classList.toggle('is-disabled', dead);
          btn.setAttribute('aria-disabled', dead ? 'true' : 'false');
        } else {
          if (countNode) countNode.textContent = '';
          btn.classList.remove('is-disabled');
          btn.setAttribute('aria-disabled', 'false');
        }
      });
      renderActive();
      renderTotal();
      // B9: una sola parada de tabulacion por grupo de botones de opcion.
      shared('refreshRoving')(drawer);
    }

    // --- Fondo inert + trampa de foco (H). Sin mover el DOM: marcamos inert/aria-hidden a
    //     TODOS los hermanos en la cadena de ancestros del drawer, dejando interactuable solo
    //     el propio drawer (que es position:fixed y tapa la pagina). Restauramos exacto lo que
    //     tocamos (no pisamos inert/aria-hidden previos del tema). ---
    var inertRecords = [];
    function markInert(el) {
      if (!el || el.nodeType !== 1) return;
      var rec = { el: el, inert: false, aria: false };
      if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); rec.inert = true; }
      if (!el.hasAttribute('aria-hidden')) { el.setAttribute('aria-hidden', 'true'); rec.aria = true; }
      if (rec.inert || rec.aria) inertRecords.push(rec);
    }
    function setBackgroundInert(on) {
      if (on) {
        var node = drawer;
        while (node && node.parentNode && node !== document.body) {
          var kids = node.parentNode.children;
          for (var i = 0; i < kids.length; i++) {
            if (kids[i] !== node) markInert(kids[i]);
          }
          node = node.parentNode;
        }
      } else {
        inertRecords.forEach(function (rec) {
          if (rec.inert) rec.el.removeAttribute('inert');
          if (rec.aria) rec.el.removeAttribute('aria-hidden');
        });
        inertRecords = [];
      }
    }
    function focusablesInPanel() {
      if (!panel) return [];
      var sel = 'a[href],button:not([disabled]):not([aria-disabled="true"]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
      return Array.prototype.slice.call(panel.querySelectorAll(sel)).filter(function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    // --- Drawer open/close ---
    function openDrawer(opener) {
      lastOpener = opener || lastOpener || document.querySelector('[data-ch-filter-open]');
      drawer.hidden = false;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.documentElement.classList.add('ch-mf-scroll-lock');
      document.body.classList.add('ch-mf-lock');
      setBackgroundInert(true);
      syncOpeners(true);
      render();
      // Foco al panel (dialogo) al abrir (H).
      if (panel) { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }
    }
    function closeDrawer() {
      var wasOpen = drawer.classList.contains('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.hidden = true;
      drawer.setAttribute('inert', '');
      document.body.classList.remove('ch-mf-lock');
      document.documentElement.classList.remove('ch-mf-scroll-lock');
      setBackgroundInert(false);
      syncOpeners(false);
      // Devolver el foco al boton "Filtrar" al cerrar (H). Solo si veniamos de abierto,
      // para no robar el foco cuando closeDrawer se llama tras un swap sin drawer abierto.
      if (wasOpen && lastOpener && typeof lastOpener.focus === 'function') {
        try { lastOpener.focus({ preventScroll: true }); } catch (e) { lastOpener.focus(); }
      }
    }

    // --- Set explicito del contador del grid (no depender de syncSaleGridCount de ui-fixes,
    //     que cuenta primero una grilla stale previa). ---
    function setGridCount(n) {
      var node = root.querySelector('[data-sale-grid-count]');
      if (!node) return;
      node.setAttribute('data-ch-filter-count-current', String(n));
      node.textContent = (n === 1) ? '1 producto' : (n + ' productos');
    }

    // --- Cambio de pagina accesible (hallazgo P1 numero 3 de la auditoria 16).
    //     Antes el swap reemplazaba el resultado y dejaba al cliente donde estaba,
    //     con el foco perdido y sin aviso. Ahora: anuncio en la region viva que
    //     sobrevive al swap, foco al inicio del resultado y vista controlada. ---
    function announceResults(page, pages, total) {
      var status = root.querySelector('[data-ch-filter-status]');
      if (!status) return;
      var message = total === 1 ? '1 producto' : total + ' productos';
      if (pages > 1 && page > 0) message = 'Página ' + page + ' de ' + pages + '. ' + message;
      status.textContent = message + '.';
    }

    function headerOffset() {
      if (typeof window.getComputedStyle !== 'function' || !document.documentElement) return 0;
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--chagual-header-offset');
      var value = parseFloat(raw);
      return isFinite(value) && value > 0 ? value : 0;
    }

    function focusResultsStart(node) {
      if (!node) return;
      try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); }
      if (typeof node.getBoundingClientRect !== 'function' || typeof window.scrollTo !== 'function') return;
      var top = node.getBoundingClientRect().top + (window.pageYOffset || 0) - headerOffset() - 8;
      window.scrollTo(0, top > 0 ? top : 0);
    }

    // Total autoritativo servido por Shopify para la URL actual. `paginate.items`
    // representa todos los resultados, también en page=2; nunca contamos cards visibles.
    function resultsTotal(scope) {
      var results = (scope || document).querySelector('[data-ch-filter-results]');
      if (!results) return null;
      var n = parseInt(results.getAttribute('data-ch-filter-total'), 10);
      return isNaN(n) || n < 0 ? null : n;
    }

    // --- Construir URL de filtro (path de tags + sort preservado) ---
    function buildUrl(tags) {
      var base = COLLECTION_URL.replace(/\/+$/, '');
      var url = tags.length ? (base + '/' + tags.join('+')) : base;
      var sort = new URLSearchParams(window.location.search).get('sort_by');
      if (sort) url += '?sort_by=' + encodeURIComponent(sort);
      return url;
    }

    // --- Apply: swap propio del grid ---
    function applySelection() {
      var tags = selectedTags();
      var url = buildUrl(tags);
      // Commit del staging -> aplicado (alimenta los chips EN LA PAGINA).
      applied = cloneSel(selected);
      renderActivePage();
      swapResults(url, true, 'apply');
    }

    var swapRequestId = 0;
    // `action` describe que hizo la persona: alimenta la medicion compartida
    // (auditoria 24, huecos 1, 2, 3 y 5) sin cambiar el flujo del swap.
    function swapResults(url, pushHistory, action) {
      // Sin `action` explicito el swap es restauracion de historial: no se mide
      // como una decision nueva de la persona.
      var intent = action || 'history';
      var current = root.querySelector('[data-ch-filter-results]');
      if (!current || typeof fetch !== 'function') {
        shared('trackFallback')('maceteros', 'sin-fetch', url);
        window.location.assign(url);
        return;
      }
      var requestId = ++swapRequestId;
      // B10: Maceteros no anunciaba NUNCA que estaba cargando. Ahora si, con la
      // guarda de secuencia que ya usaba chagual-sale-root-filter.js.
      shared('beginBusy')(root);
      fetch(url, { headers: { 'X-Requested-With': 'fetch' }, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (requestId !== swapRequestId) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ch-filter-results]');
          var live = root.querySelector('[data-ch-filter-results]');
          if (!fresh || !live) { shared('trackFallback')('maceteros', 'sin-bloque', url); window.location.assign(url); return; }
          var total = resultsTotal(doc);
          if (total == null) { shared('trackFallback')('maceteros', 'sin-total', url); window.location.assign(url); return; }
          if (!window.ChagualCollectionSeoSync || !window.ChagualCollectionSeoSync.apply(doc)) { shared('trackFallback')('maceteros', 'sin-seo-sync', url); window.location.assign(url); return; }
          var previousPage = parseInt(live.getAttribute('data-ch-filter-page'), 10);
          var freshPage = parseInt(fresh.getAttribute('data-ch-filter-page'), 10);
          var freshPages = parseInt(fresh.getAttribute('data-ch-filter-pages'), 10);
          live.replaceWith(fresh);
          if (pushHistory !== false && window.history && window.history.pushState) {
            try { window.history.pushState('', '', url); } catch (e) {}
          }
          setGridCount(total);
          closeDrawer();
          announceResults(freshPage, freshPages, total);
          if (!isNaN(freshPage) && !isNaN(previousPage) && freshPage !== previousPage) focusResultsStart(fresh);
          // Medicion compartida: faceta, valor y cantidad de resultados.
          if (intent === 'clear') shared('trackClear')('maceteros', total, url, 'drawer');
          else if (intent === 'apply') shared('trackApply')('maceteros', appliedFacets(), total, url);
          // Reenganchar consumidores propios sobre la grilla nueva.
          var catalogEvent = new Event('chagual:catalog-updated');
          catalogEvent.detail = { owner: 'maceteros', total: total, url: url };
          document.dispatchEvent(catalogEvent);
          // El modo load-more usa eventos delegados. Infinite scroll necesita un owner
          // nuevo porque el anterior quedó asociado al bloque reemplazado.
          if (window.PXUTheme && window.PXUTheme.theme_settings &&
              window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll' &&
              typeof window.enableInfiniteScroll === 'function') {
            window.enableInfiniteScroll('[data-product-list]');
          }
        })
        .catch(function () {
          if (requestId !== swapRequestId) return;
          shared('trackFallback')('maceteros', 'peticion-fallida', url);
          window.location.assign(url);
        })
        .then(function () {
          // B10: solo la respuesta vigente puede dar por terminada la carga.
          shared('endBusy')(root, requestId === swapRequestId);
        });
    }

    // --- Interacciones ---
    // Abrir drawer (boton "Filtrar" renderizado con data-ch-filter-open SOLO en maceteros).
    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-ch-filter-open]') : null;
      if (opener) { e.preventDefault(); openDrawer(opener); }
    });

    // Cerrar (backdrop / boton X)
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ch-close]')) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // Atrapar Tab dentro del panel mientras el drawer esta abierto (H).
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      var f = focusablesInPanel();
      if (!f.length) { e.preventDefault(); if (panel) panel.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || active === panel || !panel.contains(active)) { e.preventDefault(); last.focus(); }
      } else {
        if (active === last || !panel.contains(active)) { e.preventDefault(); first.focus(); }
      }
    });

    // Quitar un chip activo EN LA PAGINA (G): re-filtra al toque (swap propio), sin reabrir el cajon.
    document.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-ch-page-remove]') : null;
      if (!chip) return;
      e.preventDefault();
      var g = chip.getAttribute('data-ch-page-remove');
      delete applied[g];
      delete selected[g];
      var tags = appliedTags();
      var url = buildUrl(tags);
      renderActivePage();
      render();
      // B12: el chip pulsado ya no existe. El foco pasa al chip siguiente y, si
      // no queda ninguno, al boton "Filtrar". Este patron nacio aqui y ahora lo
      // presta el contrato compartido a los otros cuatro controladores.
      shared('focusAfterChipRemoval')(activePageRow, '[data-ch-page-remove]', document.querySelector('[data-ch-filter-open]'));
      swapResults(url, true, tags.length ? 'apply' : 'clear');
    });

    // Seleccion de opcion (mono-select por grupo, toggle)
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-ch-filter]') : null;
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-disabled')) return;
      var group = btn.getAttribute('data-group');
      var tag = btn.getAttribute('data-tag');
      if (selected[group] === tag) { delete selected[group]; }
      else { selected[group] = tag; }
      render();
    });

    // B9: el lector anuncia "grupo de botones de opcion" y hasta ahora las
    // flechas no hacian nada en Maceteros. El contrato compartido resuelve que
    // opcion sigue (flechas, Inicio y Fin, saltando las deshabilitadas) y este
    // owner conserva su estado y su render.
    shared('bindRadioKeyboard')(drawer, function (next) {
      var group = next.getAttribute('data-group');
      var tag = next.getAttribute('data-tag');
      if (!group || !tag) return;
      selected[group] = tag;
      render();
    }, ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft']);

    // Quitar un chip activo (des-stage de ese grupo)
    drawer.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-ch-remove]') : null;
      if (!chip) return;
      e.preventDefault();
      delete selected[chip.getAttribute('data-ch-remove')];
      render();
    });

    // Limpiar reemplaza el mismo bloque atomico y conserva el orden seleccionado.
    var clearBtn = drawer.querySelector('[data-ch-clear]');
    if (clearBtn) clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      GROUPS.forEach(function (g) { delete selected[g]; });
      applied = cloneSel(selected);
      render();
      renderActivePage();
      swapResults(buildUrl([]), true, 'clear');
    });

    // Ver N resultados (commit)
    if (applyBtn) applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      applySelection();
    });

    // El historial cambia la URL pero no el DOM. Restauramos el bloque completo sin
    // crear otra entrada de historial.
    window.addEventListener('popstate', function () {
      selected = selectionFromPath(window.location.pathname);
      applied = cloneSel(selected);
      render();
      renderActivePage();
      swapResults(window.location.href, false);
    });

    // Primer render (estados iniciales desde la URL)
    render();
    renderActivePage();
    var initialTotal = resultsTotal(root);
    if (initialTotal != null) setGridCount(initialTotal);
    hydrateFacetData();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
